import { notification } from 'antd';
import { useCallback, useEffect, useState } from 'react';

import apiShipper from '../../../../services/apiShipper';

const usePropostaData = ({ idCotacao }) => {
  const [propostaData, setPropostaData] = useState([]);
  const [loadingPropostaData, setLoadingPropostaData] = useState(false);

  const fetchProposta = useCallback(async () => {
    if (!idCotacao) {
      return;
    }
    setLoadingPropostaData(true);
    try {
      if (idCotacao) {
        const { data } = await apiShipper.get(
          `/cotacoes/${idCotacao}/propostas/menor-valor-empresa/`
        );

        if (data) {
          setPropostaData(data);
        }
      }
    } catch {
      notification.error({
        message: 'Não foi possível obter os dados da tabela',
        description: 'Tente novamente ou entre em contato com o suporte',
      });
    }
    setLoadingPropostaData(false);
  }, [idCotacao]);

  useEffect(() => {
    const onInit = async () => {
      await fetchProposta();
    };
    onInit();
  }, [fetchProposta]);

  return {
    propostaData,
    setPropostaData,
    loadingPropostaData,
    fetchProposta,
  };
};

export default usePropostaData;
